import { useEffect, useState } from "react";
import getSchema from "../../lib/api/getSchema";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import { ReflexContainer, ReflexElement, ReflexSplitter } from "react-reflex";
import { debounce } from 'lodash';
import FlexTabScreenType from "../screenTypes/functional/FlexTabScreenType";
import getList from "../../lib/api/getList";
import KonamMstMaterialFile from "./KonamMstMaterialFile";
import KonamMaterialByCompany from './KonamMaterialByCompany';
import { cloneDeep } from 'lodash';
import KonamAutoFormScreen from "./KonamAutoFormScreen";
import { useSetRecoilState } from "recoil";
import notificationState from "../../states/notificationState";
import { useTranslation } from "react-i18next";


function KonamMaterialManagement(props) {
    const { id } = props;

    const [schema, setSchema] = useState();

    const [api, setApi] = useState();
    const [grid, setGrid] = useState();

    const [select, setSelect] = useState();

    const [unitGroupList, setUnitGroupList] = useState([]);
    const setNotification = useSetRecoilState(notificationState);
    const { t } = useTranslation();
    const [height, setHeight] = useState(0);
    const [tab, setTab] = useState("price");
    const handleResize = () => {
        setHeight(document.documentElement.offsetHeight - 96);
    };

    useEffect(() => {

        window.addEventListener("resize", handleResize);

        handleResize();

        return () => window.removeEventListener("resize", handleResize);

    }, []);


    useEffect(() => {
        let mounted = true;
        (async () => {
            let schema = await getSchema("MomSysMstMaterial");
            const result = await getList("VwMaterialUnitGroup");

            let formSchema = cloneDeep(schema);
            for (let column of formSchema.columns) {
                switch (column.name) {
                    case "materialCode":
                    case "materialCodeVer":
                    case "materialName":
                        // case "qtySafetyStock":
                        column.hideInForm = true;
                        break;
                    default:
                        break;
                }
            }

            if (mounted) {
                setUnitGroupList(result.data);
                setSchema(schema);
            }
        })();
        return (() => {
            mounted = false;
        });
    }, []);

    useEffect(() => {
        if (grid) {
            grid.selectionChanged.addHandler(
                debounce((grid, event) => {
                    if (grid.selectedItems && grid.selectedItems[0]) {
                        setSelect({ ...grid.selectedItems[0] });

                    } else {
                        setSelect([]);
                    }
                }, 10)
            );

            grid.itemsSourceChanged.addHandler(
                debounce((grid, event) => {
                    if (grid.selectedItems && grid.selectedItems[0]) {
                        setSelect({ ...grid.selectedItems[0] });
                    } else {
                        setSelect([]);
                    }
                }, 10)
            );
        }
    }, [grid]);

    const onApiInitialized = (api) => {
        setApi(api);
    };

    const onInitialized = (grid) => {
        setGrid(grid);
    };


    const notifySuccess = (msg) => {
        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
    };

    const notifyFailure = (msg) => {
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
    };

    const onSuccess = (msg) => {
        notifySuccess(msg);
    };

    const onFailure = (reason) => {
        notifyFailure(reason.response ? reason.response.data : reason);
    };

    const notifyWarning = (msg) => {
        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });
    };

    const onNotifyWarning = (msg) => {
        notifyWarning(msg);
    };

    const onTabChanged = (tab) => {
        setTab(tab);
    };

    const checkDisabledCallback = (formData, column) => {
        if (column.name === "itemUnitName" && !!formData.unitGroupId) {
            return true;
        }
        return false;
    };

    const modifyFormDataCallback = (formData, name, value) => {
        if (name === "unitGroupId" && !!value) {
            const unitGroup = unitGroupList.find((unitGroup) => unitGroup.unitGroupId === value);

            formData.itemUnitName = unitGroup.baseUnitSymbol;
        }
    };
    const onModifyViewSchema = (modify, schema) => {

        if (modify) {

            for (const column of modify?.columns) {
                if (!column.grid) {
                    column.grid = {}
                }
                switch (column.name) {

                    case "materialCode":
                    case "materialCodeVer":
                    case "materialName":

                        column.grid.hide = false;

                        break;

                    default:
                        column.grid.hide = true;
                        break;

                }

            }

        }
    }
    return (
        <div style={{ height: height }}>
            <ReflexContainer orientation="vertical" >
                <ReflexElement flex={0.27}>
                    <BasicCrudScreenType
                        id="KonamMaterialManagement"
                        table="MomSysMstMaterial"
                        view="KonamVwMaterial"
                        onApiInitialized={onApiInitialized}
                        onInitialized={onInitialized}
                        noCreate
                        noEdit
                        noDelete
                        noExcel
                        onModifyViewSchema={onModifyViewSchema}                        
                    />
                </ReflexElement>
                <ReflexSplitter />
                <ReflexElement>
                    <ReflexContainer orientation="horizontal">
                        <ReflexElement>
                            <KonamAutoFormScreen
                                table="MomSysMstMaterial"
                                select={select}
                                isCreate
                                modifyFormDataCallback={modifyFormDataCallback}
                                checkDisabledCallback={checkDisabledCallback}
                                refresh={api}
                                grid={grid}
                                isDelete
                                onSuccess={onSuccess}
                                onFailure={onFailure}

                            />
                        </ReflexElement>
                        <ReflexSplitter />
                        <ReflexElement flex={0.45}>
                            <FlexTabScreenType
                                id="KonamMaterialManagement"
                                tabValues={
                                    [
                                        // {
                                        //     key: 1,
                                        //     value: "materialSpecInfo",
                                        //     label: "품목 규격 정보"
                                        // },
                                        // {
                                        //     key: 2,
                                        //     value: "etc",
                                        //     label: "기타"
                                        // },
                                        {
                                            key: 3,
                                            value: "image",
                                            label: "이미지"
                                        },
                                        {
                                            key: 4,
                                            value: "price",
                                            label: "단가"
                                        },
                                        // {
                                        //     key: 5,
                                        //     value: "materialInfo",
                                        //     label: "품목정보"
                                        // },
                                        // {
                                        //     key: 6,
                                        //     value: "planInfo",
                                        //     label: "계획정보"
                                        // },
                                        {
                                            key: 7,
                                            value: "stockInfo",
                                            label: "재고정보"
                                        },
                                        {
                                            key: 8,
                                            value: "orderInfo",
                                            label: "오더 정보"
                                        },

                                    ]
                                }
                                tabsStyle={{
                                    left: 0,
                                    margin: "0px",
                                    padding: "0px",
                                    height: "48px",
                                    width: "100%"
                                }}
                                onTabChanged={onTabChanged}
                                value={tab}
                            >
                                <ItemExtraInfo
                                    tab={tab}
                                    schema={schema}
                                    select={select}
                                    grid={grid}
                                    checkDisabledCallback={checkDisabledCallback}
                                    modifyFormDataCallback={modifyFormDataCallback}
                                />
                            </FlexTabScreenType>
                        </ReflexElement>
                    </ReflexContainer>
                </ReflexElement>
            </ReflexContainer>
        </div>
    );
}

function ItemExtraInfo(props) {

    const {
        tab,
        select,
    } = props;

    switch (tab) {
        case "image":
            return (
                <KonamMstMaterialFile
                    id="EguMstMaterialFile"
                    selectMstGrid={select}
                />)
        case "price":
            return (
                <KonamMaterialByCompany
                    select={select}
                />
            )
        case "stockInfo":
            return (
                <KonamAutoFormScreen
                    id="KonamStockInfo"
                    table="KonamStockInfo"
                    select={select}
                />
            )
        case "orderInfo":
            return (
                <KonamAutoFormScreen
                    id="KonamOrderInfo"
                    table="KonamOrderInfo"
                    select={select}
                />
            )
        default:
            <></>
            break;
    }
}
export default KonamMaterialManagement;
